import { render, staticRenderFns } from "./system-user-detail.vue?vue&type=template&id=0aec0137"
import script from "./system-user-detail.vue?vue&type=script&lang=js"
export * from "./system-user-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports